const removeAllExtensions = (fileName: string): string => fileName.replace(/(\.[^./]+)+$/, "")

const normalizeImageKey = (rawPath: string): string => {
  const fileName = rawPath.split("/").pop()

  return fileName ? removeAllExtensions(fileName).toLowerCase() : ""
}

const audienceImageModules = import.meta.glob("../../assets/images/landing/audiences/*", {
  eager: true,
  import: "default",
}) as Record<string, string>

const audienceImagesByKey = Object.entries(audienceImageModules).reduce<Record<string, string>>(
  (accumulator, [path, url]) => {
    const key = normalizeImageKey(path)

    if (key) {
      accumulator[key] = url
    }

    return accumulator
  },
  {},
)

export const resolveAudienceImagePath = (imagePath: string): string => {
  const key = normalizeImageKey(imagePath)

  return key ? (audienceImagesByKey[key] ?? imagePath) : imagePath
}
